import React from 'react';
// import { graphql } from 'gatsby';

import Layout from '../_layout/layout';
import SEO from '../_layout/seo';

import HomeHero from '../_components/homepage/hero';
import HomeFeaturedArticles from '../_components/homepage/featured-articles';
import HomeBenefits from '../_components/homepage/benefits';
import HomeCertificates from '../_components/homepage/certificates';
import JobSimpleSearch from '../_components/jobspage/simple-search';
import HomeLatestJobs from '../_components/homepage/jobs-latest';

import SidebarAds from '../_components/shares/sidebar-ads';
// import SidebarExternalArticlesLatest from '../_components/shares/sidebar-external-articles-latest';
import JournalFeaturedPosts from '../_components/shares/journal-featured-posts';

import MediaLinkLogo from '../_components/shares/media-link-logo';

const IndexPage = () => (
  <Layout>
    <SEO
      keywords={[
        `Clarity`,
        `クラリティ`,
        `転職`,
        `採用`,
        `年収`,
        `給料`,
        `福利厚生`,
        `評価`,
        `クチコミ`,
      ]}
    />

    <HomeHero />

    <section className="home-articles-wraper">
      <div className="container-fluid max-1100">
        <HomeFeaturedArticles />
      </div>
    </section>

    {/*  */}
    <div className="container-fluid px-0 max-1100">
      <div className="row mx-0">
        <div className="col-lg-9 col-12">
          {/* home latest jobs */}
          <JobSimpleSearch />
          <HomeLatestJobs />

          {/* home benefit */}
          <HomeBenefits />

          {/* home certificates */}
          <HomeCertificates />
        </div>
        <div className="col-lg-3 col-12 sidebar-wrapper">
          {/* sidebarAds */}
          <SidebarAds />

          {/* JournalFeaturedPosts */}
          <JournalFeaturedPosts />

          {/* external articles latest */}
          {/* <SidebarExternalArticlesLatest /> */}
        </div>
      </div>
    </div>
    <div className="container-fluid px-0">
      {/* MediaLinkLogo */}
      <MediaLinkLogo />
    </div>
  </Layout>
);

export default IndexPage;
